import { Request } from '@konv/http';
import  Axios  from 'axios';
export class OpenDeliveryApi {
  static async request({
    endpoint = "/",
    method = "GET",
    headers = {},
    query = {},
    data = {},
  }) {
    return await Request.request({
      endpoint: endpoint,
      cors: true,
      method: method || "GET",
      headers: headers || {},
      service: "open-delivery",
      ignoreVersion: true,
      params: query || {},
      data: data || {},
    });
  }

  static async postTokenOpenDelivery({ client_id, client_secret }) {
    const axiosInstance = Axios.create();
  
    axiosInstance.interceptors.request.use(config => {
        if (config.headers['X-Override-Content-Type']) {
            config.headers['Content-Type'] = config.headers['X-Override-Content-Type'];
            delete config.headers['X-Override-Content-Type'];
        }
        return config;
    });
  
    const data = new URLSearchParams();
    data.append('client_id', client_id);
    data.append('client_secret', client_secret);
    data.append('grant_type', 'client_credentials');
  
    const serviceAddress = await Request.loadServiceAddress('open-delivery');
    const endpoint = '/oauth/token';
  
    return axiosInstance.post(`${serviceAddress}${endpoint}`, data.toString(), {
        headers: {
            'Content-Type': 'application/json', 
            'X-Override-Content-Type': 'application/x-www-form-urlencoded', 
        },
    });
  }
  




  static async postOpenDeliveryRefresh({ client_id, client_secret }) {
    const tokenData = await this.postTokenOpenDelivery({ client_id, client_secret });
    const token = tokenData?.data?.access_token;
    return await OpenDeliveryApi.request({
      endpoint: `/v1/merchantUpdate`,
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

}
